import styled from '@emotion/styled';
import { Tab } from '@mui/material';
import { colors } from 'theme/colors';

const StyledTab = styled(Tab)`
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.02em;
  font-weight: 400;
  text-transform: none;
  color: ${colors.blue600};
  min-height: 47px;

  &.Mui-selected {
    font-weight: 700;
    color: ${colors.blue600};
  }

  & svg {
    margin-top: 3px;
    margin-right: 8px;
  }
`;

export { StyledTab };
